import { inject, observer } from 'mobx-react';
import b from 'b_';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import CategoriesSectionStore from '../../../stores/Policy/CategoriesSectionStore';
import { ModalMode } from '../../../stores/Policy/PolicyModalStore';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import FuseButton from '../../FuseControls/FuseButton';
import FuseReadOnlyCheckbox from '../../FuseControls/FuseReadOnlyCheckbox';
import FuseReadOnlySelect from '../../FuseControls/FuseReadOnlySelect';
import PolicySection from '../PolicySection';
import PolicySectionHeader from '../PolicySectionHeader/PolicySectionHeader';
import CheckboxContainer from '../../CheckboxContainer/CheckboxContainer';
import FuseConsoleCardFooter from '../../ConsoleFragments/FuseConsoleCardFooter';
import { FTBody } from '../../Fuse';
import './CategoriesSection.css';

const block = b.lock('CategoriesSection');

class CategoriesSection extends Component {
    static propTypes = {
        store: CategoriesSectionStore.PropType.isRequired,
        readOnly: PropTypes.bool,
        policy: PolicyStore.PropType.isRequired,
    };

    componentDidMount() {
        this.props.store.load();
    }

    onCreateCategoryButton = () => {
        const { store, policy } = this.props;

        policy.customCategories.policyTable.openModal(ModalMode.CREATE, null, (item) => {
            store.load()
                .then(() => store.selectCustomCategory(item));
        });
    };

    createCustomSectionBtn = (disable) => <FuseButton
        type="tertiary"
        icon="add_circle"
        wrapperClassName={block('AddButtonWrapper')}
        color="blue"
        disabled={disable}
        onClick={this.onCreateCategoryButton}
    >New Custom Category</FuseButton>

    standardSection = ({ store, readOnly, disable }) => <div className={block('CategorySection')}>
        <PolicySectionHeader title="Standard Categories" />
        <FuseReadOnlySelect
            readOnly={readOnly}
            store={store.standardCategoriesSelect}
            selectAllEnabled
            fullWidth
            searchable
            searchLabel="Search by Name or Domain"
            placeholder="Select Standard Categories"
            noOptionsLabel="No entries found"
            loading={store.searchStandardCategoriesStatus.isLoading}
            onFilter={store.searchStandardCategories}
            disabled={disable}
            qa="standard-categories"
        />
    </div>;

    customSection = ({ readOnly, store, disable }) => <div
        className={block('CategorySection', { type: 'custom' })}
    >
        <PolicySectionHeader title="Custom Categories">
            {!readOnly ? this.createCustomSectionBtn(disable) : null}
        </PolicySectionHeader>

        <FuseReadOnlySelect
            readOnly={readOnly}
            store={store.customerCategoriesSelect}
            selectAllEnabled
            fullWidth
            searchable
            noOptionsLabel="No entries found"
            searchLabel="Search by Name or Domain"
            placeholder="Select Custom Categories"
            qa="custom-categories"
            disabled={disable}
        />
    </div>;

    sections = ({ readOnly, store, disable }) => <Fragment>
        {(!readOnly || store.customerCategoriesSelect.selectedValues.length > 0) ?
            this.customSection({ readOnly, store, disable }) :
            null
        }
        {(!readOnly || store.standardCategoriesSelect.selectedValues.length > 0) ?
            this.standardSection({ store, readOnly, disable }) :
            null
        }
    </Fragment>;

    render = () => {
        const { store, policy } = this.props;
        let { readOnly } = this.props;
        readOnly = readOnly || store.isDefault;
        const disable = policy.redirectRules.showNoBrowsingRoleEnabledAlert.getValue();

        if (readOnly && !store.matchAllCategories.value) {
            return this.sections({ readOnly, store, disable });
        }

        return <PolicySection grayBackground={!readOnly} readOnly={readOnly}>
            <PolicySectionHeader
                title="Categories"
                tooltipText={`Select the categories you would like to be included in this match criteria.
                You can also select Match All to match every URL.`}
                isFixedTooltip
            />
            <CheckboxContainer className={block('CategoriesControls')}>
                <FuseReadOnlyCheckbox
                    readOnly={readOnly}
                    store={store.matchAllCategories}
                    label={!readOnly ? 'Match All URLs' : <FTBody>{'All URLs'}</FTBody>}
                    qa="match-all-categories"
                    disabled={disable}
                />
                {(store.matchAllCategories.isTrue && !readOnly) ?
                    this.createCustomSectionBtn(disable) :
                    null
                }
            </CheckboxContainer>
            {!store.matchAllCategories.value ?
                this.sections({ readOnly, store, disable }) :
                null
            }
            {!readOnly ? <FuseConsoleCardFooter
                className={block('SectionFooter')}
                text={'At least one Category is required to be selected.'}
            /> : null}
        </PolicySection>;
    }
}
export default inject('policy')(observer(CategoriesSection));
